// Campus photo for /colleges/university-of-notre-dame: CC BY-SA 4.0, by Matthew Rice, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMain_Building_at_the_University_of_Notre_Dame.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-notre-dame/; credited under the photo.
const photo = {
    "slug": "university-of-notre-dame",
    "alt": "The Main Building and its Golden Dome at the University of Notre Dame in Notre Dame, Indiana",
    "src": "/colleges/university-of-notre-dame/campus-1600.webp",
    "srcSmall": "/colleges/university-of-notre-dame/campus-800.webp",
    "srcMid": "/colleges/university-of-notre-dame/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-notre-dame/og.jpg",
    "title": "Main Building at the University of Notre Dame",
    "author": "Matthew Rice",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMain_Building_at_the_University_of_Notre_Dame.jpg",
    "read": "2026-10-01"
};

export default photo;
